import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowUpS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4.1902 11.7786C3.93054 11.4899 3.93675 11.0552 4.19215 10.7737L11.4939 4.19654C11.792 3.93219 12.2163 3.93219 12.4998 4.19459L19.7498 10.719C20.0575 10.996 20.0822 11.4707 19.8054 11.7786C19.5283 12.0864 19.0537 12.1113 18.7459 11.8342L12.7478 6.4358V19.2522C12.7478 19.6663 12.4119 20.0021 11.9978 20.0022C11.5836 20.0022 11.2478 19.6664 11.2478 19.2522V6.4358L5.1902 11.8821C4.88339 12.1068 4.45008 12.0673 4.1902 11.7786Z",
            fill: color
        })
    });

//# sourceMappingURL=arrow-up-s.js.map